// import { TimelineMax, Power0, TweenMax } from 'gsap/all';

export default class Footer {
	constructor(name) {
		this.name = name;

		// this.init();
	}

	init() {
		// const targets = document.querySelectorAll('.footer__bottom > div');
		// const hiaLoaderWhite = document.querySelectorAll('#hia-loader-white');
		// // console.log('Footer init.', targets);
		// var action = new TimelineMax({ paused: true })
		// 	.to('.line', 0.6, { height: 40 })
		// 	.fromTo('.footer__copyrights', 0.5, { opacity: 0 }, { opacity: 1 })
		// 	.fromTo('.footer__madeby', 0.6, { opacity: 0 }, { opacity: 1 });
		// jQuery('.menu__item').on('click',
		// 	function() {
		// 		TweenMax.to(hiaLoaderWhite, 0.8, {
		// 			visibility: 'visible'
		// 		});
		// 	});
		// const options = {
		// 	threshold: 1, //100% of SVG height is visible, observer should be triggered
		// };
		// const callback = entries => {
		// 	entries.forEach(entry => {
		// 		if (entry.isIntersecting) {
		// 			action.play();
		// 		} else {
		// 			action.pause(0);
		// 		}
		// 	});
		// };
		// const observer = new IntersectionObserver(callback, options);
		// targets.forEach(target => observer.observe(target));
		// return true;
	}
}
